/* ==========================================================================
   Video with Accessibility — JavaScript
   Supports:
     1. Standalone video sections (.section-video-ada without .dt-video-block)
     2. Gallery blocks (.dt-video-block inside .section-video-ada)
   Each video instance gets its own independent CC/AD/transcript/pause state.
   ========================================================================== */

(function () {
  'use strict';

  var DEBOUNCE_MS = 300;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var sections = document.querySelectorAll('.section-video-ada');
    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      var blocks = section.querySelectorAll('.dt-video-block');

      if (blocks.length > 0) {
        for (var j = 0; j < blocks.length; j++) {
          initBlock(blocks[j], section);
        }
      } else {
        initBlock(section, section);
      }
    }
  });

  /* ------------------------------------------------------------------
     initBlock(scope, section)
     scope  = the element containing the controls and video
              (the block div for gallery, or the section for standalone)
     section = the parent section (used to find transcript drawers and
               VTT JSON that live outside the scope)
     ------------------------------------------------------------------ */

  function initBlock(scope, section) {
    var blockId = scope.getAttribute('data-dt-block-id');

    var pauseBtn       = scope.querySelector('[data-dt-pause-toggle]');
    var ccBtn          = scope.querySelector('[data-dt-cc-toggle]');
    var adBtn          = scope.querySelector('[data-dt-ad-toggle]');
    var transcriptBtn  = scope.querySelector('[data-dt-transcript-toggle]');
    var liveRegion     = scope.querySelector('.dt-a11y-live');
    var captionOverlay = scope.querySelector('[data-dt-caption-overlay]');
    var captionText    = scope.querySelector('[data-dt-caption-text]');
    var ccVideoWrap    = scope.querySelector('[data-dt-cc-video]');
    var adVideoWrap    = scope.querySelector('[data-dt-ad-video]');

    var drawer, transcriptClose, captionsJson;

    if (blockId) {
      drawer          = section.querySelector('.dt-transcript-drawer[data-dt-block-id="' + blockId + '"]');
      captionsJson    = section.querySelector('[data-dt-captions][data-dt-block-id="' + blockId + '"]');
    } else {
      drawer          = scope.querySelector('.dt-transcript-drawer');
      captionsJson    = scope.querySelector('[data-dt-captions]');
    }

    if (drawer) {
      transcriptClose = drawer.querySelector('[data-dt-transcript-close]');
    }

    var ccActive = false;
    var adActive = false;
    var isPaused = false;
    var vttCues = null;
    var vttLoading = false;

    var lastCcClick = 0;
    var lastAdClick = 0;
    var lastTranscriptClick = 0;
    var lastPauseClick = 0;

    console.log('[Video ADA] Init', blockId ? 'block ' + blockId : 'section',
      '| Pause:', !!pauseBtn, '| CC:', !!ccBtn, '| AD:', !!adBtn,
      '| Transcript:', !!transcriptBtn, '| Drawer:', !!drawer,
      '| ReducedMotion:', prefersReducedMotion);

    /* ------------------------------------------------------------------
       Helper: find the primary video in this scope
       ------------------------------------------------------------------ */

    function getPrimaryVideo() {
      var v = scope.querySelector('video-component video');
      if (!v) v = scope.querySelector('deferred-media video');
      if (!v) v = scope.querySelector('video');
      return v;
    }

    /* Get whichever video is currently "active" (AD > CC swap > primary) */
    function getActiveVideo() {
      if (adActive && adVideoWrap) {
        var v = adVideoWrap.querySelector('video');
        if (v) return v;
      }
      if (ccActive && ccVideoWrap) {
        var v = ccVideoWrap.querySelector('video');
        if (v) return v;
      }
      return getPrimaryVideo();
    }

    /* Get ALL videos in scope (primary + alt) */
    function getAllVideos() {
      return scope.querySelectorAll('video');
    }

    /* ------------------------------------------------------------------
       prefers-reduced-motion: auto-pause on load
       ------------------------------------------------------------------ */

    if (prefersReducedMotion) {
      var attemptPause = function () {
        var videos = getAllVideos();
        if (videos.length > 0) {
          for (var k = 0; k < videos.length; k++) {
            videos[k].pause();
          }
          isPaused = true;
          if (pauseBtn) {
            pauseBtn.setAttribute('aria-checked', 'true');
            updatePauseIcon(pauseBtn, true);
          }
          scope.classList.add('dt-video-paused');
          console.log('[Video ADA] Auto-paused (prefers-reduced-motion)', blockId || '');
        }
      };

      /* Try immediately and also after short delay for deferred-media */
      attemptPause();
      setTimeout(attemptPause, 500);
      setTimeout(attemptPause, 1500);

      /* Also observe for video elements being added (deferred-media pattern) */
      var observer = new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          for (var n = 0; n < mutations[m].addedNodes.length; n++) {
            var node = mutations[m].addedNodes[n];
            if (node.nodeName === 'VIDEO' || (node.querySelectorAll && node.querySelectorAll('video').length > 0)) {
              attemptPause();
            }
          }
        }
      });
      observer.observe(scope, { childList: true, subtree: true });

      /* Clean up observer after 10s */
      setTimeout(function () { observer.disconnect(); }, 10000);
    }

    /* ------------------------------------------------------------------
       Pause / Play helpers
       ------------------------------------------------------------------ */

    function updatePauseIcon(btn, paused) {
      var playIcon = btn.querySelector('.dt-icon-play');
      var pauseIcon = btn.querySelector('.dt-icon-pause');
      if (playIcon && pauseIcon) {
        playIcon.style.display = paused ? 'block' : 'none';
        pauseIcon.style.display = paused ? 'none' : 'block';
      }
    }

    function pauseAllVideos() {
      var videos = getAllVideos();
      for (var k = 0; k < videos.length; k++) {
        videos[k].pause();
      }
    }

    function resumeActiveVideo() {
      /* Resume whichever video is currently active (primary, CC, or AD) */
      if (adActive && adVideoWrap) {
        var adVid = adVideoWrap.querySelector('video');
        if (adVid) adVid.play().catch(function () {});
      } else if (ccActive && ccVideoWrap) {
        var ccVid = ccVideoWrap.querySelector('video');
        if (ccVid) ccVid.play().catch(function () {});
      } else {
        var primary = getPrimaryVideo();
        if (primary) primary.play().catch(function () {});
      }
    }

    /* ------------------------------------------------------------------
       0. Pause/Play Toggle
       ------------------------------------------------------------------ */

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();

        var now = Date.now();
        if (now - lastPauseClick < DEBOUNCE_MS) return;
        lastPauseClick = now;

        isPaused = !isPaused;
        pauseBtn.setAttribute('aria-checked', String(isPaused));
        updatePauseIcon(pauseBtn, isPaused);

        if (isPaused) {
          pauseAllVideos();
          scope.classList.add('dt-video-paused');
        } else {
          resumeActiveVideo();
          scope.classList.remove('dt-video-paused');
        }

        announce(liveRegion, isPaused ? 'Video paused' : 'Video playing');
        console.log('[Video ADA] Pause toggled:', isPaused, blockId || '');
      });
    }

    /* ------------------------------------------------------------------
       Transcript open/close — inline styles
       ------------------------------------------------------------------ */

    function openTranscript() {
      if (!drawer) return;
      drawer.style.setProperty('display', 'block', 'important');
      drawer.setAttribute('aria-hidden', 'false');
      if (transcriptBtn) transcriptBtn.setAttribute('aria-checked', 'true');
      announce(liveRegion, 'Transcript opened');
      console.log('[Video ADA] Transcript OPENED', blockId || '');
    }

    function closeTranscript() {
      if (!drawer) return;
      drawer.style.setProperty('display', 'none', 'important');
      drawer.setAttribute('aria-hidden', 'true');
      if (transcriptBtn) transcriptBtn.setAttribute('aria-checked', 'false');
      announce(liveRegion, 'Transcript closed');
      console.log('[Video ADA] Transcript CLOSED', blockId || '');
    }

    /* ------------------------------------------------------------------
       1. Transcript
       ------------------------------------------------------------------ */

    if (transcriptBtn && drawer) {
      transcriptBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();

        var now = Date.now();
        if (now - lastTranscriptClick < DEBOUNCE_MS) return;
        lastTranscriptClick = now;

        var isOn = transcriptBtn.getAttribute('aria-checked') === 'true';
        if (isOn) closeTranscript();
        else openTranscript();
      });
    }

    if (transcriptClose && drawer && transcriptBtn) {
      transcriptClose.addEventListener('click', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();
        closeTranscript();
        transcriptBtn.focus();
      });
    }

    /* ------------------------------------------------------------------
       Determine CC mode: 'swap' (burned-in video) or 'vtt' (overlay)
       ------------------------------------------------------------------ */

    var ccMode = ccVideoWrap ? 'swap' : ((captionOverlay && captionText) ? 'vtt' : null);

    /* ------------------------------------------------------------------
       2. CC Toggle
       ------------------------------------------------------------------ */

    if (ccBtn) {
      ccBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();

        var now = Date.now();
        if (now - lastCcClick < DEBOUNCE_MS) return;
        lastCcClick = now;

        ccActive = !ccActive;
        ccBtn.setAttribute('aria-checked', String(ccActive));
        console.log('[Video ADA] CC toggled:', ccActive, '(mode:', ccMode + ')', blockId || '');

        var primaryVideo = getPrimaryVideo();

        if (ccMode === 'swap') {
          /* Burned-in CC video — mutually exclusive with AD */
          if (ccActive) {
            if (primaryVideo) showAltVideo(ccVideoWrap, primaryVideo, true);
            else ccVideoWrap.classList.add('dt-active');
            /* Force AD off */
            if (adActive) {
              adActive = false;
              if (adBtn) adBtn.setAttribute('aria-checked', 'false');
              if (adVideoWrap) hideAltVideo(adVideoWrap);
              announce(liveRegion, 'Audio description off');
            }
            if (isPaused) pauseAllVideos();
          } else {
            hideAltVideo(ccVideoWrap);
            if (!isPaused && primaryVideo) primaryVideo.play().catch(function () {});
          }

        } else if (ccMode === 'vtt') {
          /* VTT overlay — can coexist with AD */
          if (ccActive) {
            captionOverlay.removeAttribute('hidden');
            /* Bind VTT to whichever video is currently active */
            var activeVid = getActiveVideo();
            if (activeVid) loadAndBindVTT(activeVid);
          } else {
            captionOverlay.setAttribute('hidden', '');
            captionText.textContent = '';
          }
        }

        announce(liveRegion, ccActive ? 'Closed captions on' : 'Closed captions off');
      });
    }

    /* ------------------------------------------------------------------
       3. AD Toggle
       ------------------------------------------------------------------ */

    if (adBtn && adVideoWrap) {
      adBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();

        var now = Date.now();
        if (now - lastAdClick < DEBOUNCE_MS) return;
        lastAdClick = now;

        adActive = !adActive;
        adBtn.setAttribute('aria-checked', String(adActive));
        console.log('[Video ADA] AD toggled:', adActive, blockId || '');

        var primaryVideo = getPrimaryVideo();

        if (adActive) {
          if (primaryVideo) showAltVideo(adVideoWrap, primaryVideo, false);
          else adVideoWrap.classList.add('dt-active');

          if (ccMode === 'swap' && ccActive) {
            /* Burned-in CC — force CC off */
            ccActive = false;
            if (ccBtn) ccBtn.setAttribute('aria-checked', 'false');
            if (ccVideoWrap) hideAltVideo(ccVideoWrap);
            announce(liveRegion, 'Closed captions off');
          } else if (ccMode === 'vtt' && ccActive) {
            /* VTT captions — rebind to AD video so captions track it */
            var adVid = adVideoWrap.querySelector('video');
            if (adVid) loadAndBindVTT(adVid);
          }

          if (isPaused) pauseAllVideos();
        } else {
          hideAltVideo(adVideoWrap);
          if (!isPaused && primaryVideo) primaryVideo.play().catch(function () {});

          /* If VTT captions are still on, rebind to primary */
          if (ccMode === 'vtt' && ccActive && primaryVideo) {
            loadAndBindVTT(primaryVideo);
          }
        }

        announce(liveRegion, adActive ? 'Audio description on' : 'Audio description off');
      });
    }

    /* ------------------------------------------------------------------
       VTT: Fetch, parse, bind timeupdate
       Supports binding to multiple videos (e.g. primary AND AD video)
       ------------------------------------------------------------------ */

    var boundVideos = [];

    function loadAndBindVTT(video) {
      if (vttCues) { bindTimeUpdate(video); return; }
      if (vttLoading) return;
      if (!captionsJson) return;

      vttLoading = true;

      try {
        var data = JSON.parse(captionsJson.textContent);
        if (!data.src) { vttLoading = false; return; }

        fetch(data.src)
          .then(function (res) {
            if (!res.ok) throw new Error('VTT fetch failed: ' + res.status);
            return res.text();
          })
          .then(function (raw) {
            vttCues = parseVTT(raw);
            console.log('[Video ADA] Parsed', vttCues.length, 'cues', blockId || '');
            bindTimeUpdate(video);
          })
          .catch(function (err) {
            console.error('[Video ADA] VTT fetch error:', err);
            vttLoading = false;
          });
      } catch (err) {
        console.error('[Video ADA] Captions JSON parse error:', err);
        vttLoading = false;
      }
    }

    function bindTimeUpdate(video) {
      /* Avoid duplicate binding to the same video element */
      for (var b = 0; b < boundVideos.length; b++) {
        if (boundVideos[b] === video) return;
      }
      boundVideos.push(video);

      video.addEventListener('timeupdate', function () {
        if (!ccActive || !vttCues || !captionText) return;
        /* Only render captions from the currently active video */
        var active = getActiveVideo();
        if (active !== video) return;

        var t = video.currentTime;
        var activeCue = null;
        for (var i = 0; i < vttCues.length; i++) {
          if (t >= vttCues[i].start && t < vttCues[i].end) { activeCue = vttCues[i]; break; }
        }
        captionText.textContent = activeCue ? activeCue.text : '';
      });

      console.log('[Video ADA] VTT bound to video', boundVideos.length, blockId || '');
    }

    /* ------------------------------------------------------------------
       4. Keyboard Shortcuts (scoped to this block/section)
       ------------------------------------------------------------------ */

    scope.addEventListener('keydown', function (e) {
      var tag = e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || e.target.isContentEditable) return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;

      switch (e.key.toLowerCase()) {
        case ' ': if (pauseBtn) { e.preventDefault(); pauseBtn.click(); } break;
        case 'k': if (pauseBtn) { e.preventDefault(); pauseBtn.click(); } break;
        case 'c': if (ccBtn) { e.preventDefault(); ccBtn.click(); } break;
        case 'd': if (adBtn) { e.preventDefault(); adBtn.click(); } break;
        case 't': if (transcriptBtn) { e.preventDefault(); transcriptBtn.click(); } break;
      }
    });
  }

  /* ======================================================================
     VTT Parser
     ====================================================================== */

  function parseVTT(raw) {
    var cues = [];
    var lines = raw.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
    var i = 0;
    while (i < lines.length && lines[i].indexOf('-->') === -1) i++;
    while (i < lines.length) {
      var line = lines[i].trim();
      if (line.indexOf('-->') !== -1) {
        var parts = line.split('-->');
        var start = parseTimestamp(parts[0].trim());
        var endStr = parts[1].trim().split(' ')[0];
        var end = parseTimestamp(endStr);
        var textLines = [];
        i++;
        while (i < lines.length && lines[i].trim() !== '') { textLines.push(lines[i].trim()); i++; }
        if (!isNaN(start) && !isNaN(end) && textLines.length > 0) {
          cues.push({ start: start, end: end, text: textLines.join('\n').replace(/<[^>]+>/g, '') });
        }
      } else { i++; }
    }
    return cues;
  }

  function parseTimestamp(str) {
    var parts = str.split(':');
    if (parts.length === 3) return parseFloat(parts[0]) * 3600 + parseFloat(parts[1]) * 60 + parseFloat(parts[2]);
    if (parts.length === 2) return parseFloat(parts[0]) * 60 + parseFloat(parts[1]);
    return NaN;
  }

  /* ======================================================================
     Helpers
     ====================================================================== */

  function showAltVideo(altWrap, primaryVideo, keepMuted) {
    var altVideo = altWrap.querySelector('video');
    if (!altVideo) return;
    altWrap.classList.add('dt-active');
    altWrap.setAttribute('aria-hidden', 'false');
    altVideo.muted = keepMuted;
    try { altVideo.currentTime = primaryVideo.currentTime || 0; } catch (e) {}
    altVideo.play().catch(function () {});
    primaryVideo.pause();
  }

  function hideAltVideo(altWrap) {
    var altVideo = altWrap.querySelector('video');
    if (altVideo) altVideo.pause();
    altWrap.classList.remove('dt-active');
    altWrap.setAttribute('aria-hidden', 'true');
  }

  function announce(liveRegion, message) {
    if (!liveRegion) return;
    liveRegion.textContent = '';
    requestAnimationFrame(function () { liveRegion.textContent = message; });
  }

})();